// 所有工具配置映射 - 支持本地转换
// 包含 98 项功能的完整配置

export const convertToolConfigs = {
  // Video & Audio (8项)
  'video-converter': {
    title: 'Video Converter',
    description: 'Convert video files to any format. Supports MP4, AVI, MOV, WMV, FLV, WEBM, MKV and more.',
    inputTypes: ['asf', 'avi', 'f4v', 'flv', 'gif', 'm2ts', 'm4a', 'm4v', 'mka', 'mkv', 'mov', 'mp3', 'mp4', 'mpeg', 'mpg', 'mts', 'ogg', 'ogv', 'ra', 'rm', 'ts', 'tta', 'vob', 'wav', 'webm', 'wmv', 'wv'],
    outputTypes: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'gif', 'asf', 'f4v', 'm2ts', 'm4v', 'mka', 'mpeg', 'mpg', 'mts', 'ogv', 'ts', 'vob', 'webm'],
    category: 'video',
    icon: '🎬'
  },
  'audio-converter': {
    title: 'Audio Converter',
    description: 'Convert audio files between MP3, WAV, FLAC, AAC, OGG, M4A, OPUS, WMA and more formats. Also supports extracting audio from video files.',
    inputTypes: ['aac', 'aiff', 'au', 'avi', 'caf', 'f4v', 'flac', 'flv', 'm2ts', 'm4a', 'm4v', 'mka', 'mkv', 'mov', 'mp3', 'mp4', 'mpeg', 'mpg', 'mts', 'ogg', 'ogv', 'paf', 'ra', 'rm', 'sd2', 'ts', 'tta', 'vob', 'wav', 'webm', 'wma', 'wv'],
    outputTypes: ['aac', 'aiff', 'au', 'caf', 'flac', 'm4a', 'mka', 'mp3', 'ogg', 'ra', 'rm', 'tta', 'wav', 'webm', 'wma', 'wv'],
    category: 'audio',
    icon: '🎵'
  },
  'mp3-converter': {
    title: 'MP3 Converter',
    description: 'Convert any audio file to MP3, WAV, FLAC, AAC, OGG, M4A, OPUS, WMA and more formats.',
    inputTypes: ['wav', 'flac', 'aac', 'ogg', 'm4a', 'mp4', 'mp3', 'wma', 'opus', 'amr', 'aiff', 'au', 'ra', 'm4b', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', 'asf', 'f4v', 'm2ts', 'mts', 'mpeg', 'mpg', 'ogv', 'paf', 'rm', 'sd2', 'ts', 'tta', 'vob', 'wv', 'caf', 'mka'],
    outputTypes: ['mp3', 'wav', 'flac', 'aac', 'ogg', 'm4a', 'opus', 'wma', 'amr', 'aiff', 'au'],
    defaultOutput: 'mp3',
    category: 'audio',
    icon: '🎵'
  },
  'mp4-to-mp3': {
    title: 'MP4 to MP3 Converter',
    description: 'Extract audio from MP4 video files and convert to MP3.',
    inputTypes: ['mp4'],
    outputTypes: ['mp3'],
    defaultOutput: 'mp3',
    category: 'audio',
    icon: '🎵'
  },
  'video-to-mp3': {
    title: 'Video to MP3 Converter',
    description: 'Extract audio from any video file and convert to MP3 format.',
    inputTypes: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm'],
    outputTypes: ['mp3'],
    defaultOutput: 'mp3',
    category: 'audio',
    icon: '🎵'
  },
  'mp4-converter': {
    title: 'MP4 Converter',
    description: 'Convert videos to MP4 format. Supports AVI, MOV, WMV, FLV, WEBM and more.',
    inputTypes: ['avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'],
    outputTypes: ['mp4'],
    defaultOutput: 'mp4',
    category: 'video',
    icon: '🎬'
  },
  'mov-to-mp4': {
    title: 'MOV to MP4 Converter',
    description: 'Convert MOV video files to MP4 format.',
    inputTypes: ['mov'],
    outputTypes: ['mp4'],
    defaultOutput: 'mp4',
    category: 'video',
    icon: '🎬'
  },
  'mp3-to-ogg': {
    title: 'MP3 to OGG Converter',
    description: 'Convert MP3 audio files to OGG format.',
    inputTypes: ['mp3'],
    outputTypes: ['ogg'],
    defaultOutput: 'ogg',
    category: 'audio',
    icon: '🎵'
  },
  'avi-converter': {
    title: 'AVI Converter',
    description: 'Convert AVI videos to MP4, MOV, WEBM and other formats.',
    inputTypes: ['avi'],
    outputTypes: ['mp4', 'mov', 'webm', 'mkv', 'gif'],
    category: 'video',
    icon: '🎬'
  },
  'webm-converter': {
    title: 'WebM Converter',
    description: 'Convert WebM videos to MP4, AVI, MOV and other formats.',
    inputTypes: ['webm'],
    outputTypes: ['mp4', 'avi', 'mov', 'mkv', 'gif'],
    category: 'video',
    icon: '🎬'
  },
  'mkv-converter': {
    title: 'MKV Converter',
    description: 'Convert MKV videos to MP4, AVI, MOV and other formats.',
    inputTypes: ['mkv'],
    outputTypes: ['mp4', 'avi', 'mov', 'webm', 'gif'],
    category: 'video',
    icon: '🎬'
  },
  'wav-converter': {
    title: 'WAV Converter',
    description: 'Convert WAV audio files to MP3, FLAC, AAC, OGG and other formats.',
    inputTypes: ['wav'],
    outputTypes: ['mp3', 'flac', 'aac', 'ogg', 'm4a'],
    category: 'audio',
    icon: '🎵'
  },
  'flac-converter': {
    title: 'FLAC Converter',
    description: 'Convert FLAC audio files to MP3, WAV, AAC, OGG and other formats.',
    inputTypes: ['flac'],
    outputTypes: ['mp3', 'wav', 'aac', 'ogg', 'm4a'],
    category: 'audio',
    icon: '🎵'
  },
  'aac-converter': {
    title: 'AAC Converter',
    description: 'Convert AAC audio files to MP3, WAV, FLAC, OGG and other formats.',
    inputTypes: ['aac', 'm4a'],
    outputTypes: ['mp3', 'wav', 'flac', 'ogg'],
    category: 'audio',
    icon: '🎵'
  },

  // Image (8项)
  'image-converter': {
    title: 'Image Converter',
    description: 'Convert images between JPG, PNG, WEBP, SVG, HEIC, GIF, BMP and more formats.',
    inputTypes: ['arw', 'avif', 'bmp', 'cr2', 'cr3', 'dng', 'eps', 'gif', 'heic', 'ico', 'jpeg', 'jpg', 'nef', 'orf', 'pcx', 'png', 'psd', 'raf', 'raw', 'rw2', 'sr2', 'tga', 'tiff', 'webp'],
    outputTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'ico', 'pdf', 'avif', 'tga', 'pcx'],
    category: 'image',
    icon: '🖼️'
  },
  'webp-to-png': {
    title: 'WEBP to PNG Converter',
    description: 'Convert WEBP images to PNG format.',
    inputTypes: ['webp'],
    outputTypes: ['png'],
    defaultOutput: 'png',
    category: 'image',
    icon: '🖼️'
  },
  'jfif-to-png': {
    title: 'JFIF to PNG Converter',
    description: 'Convert JFIF images to PNG format.',
    inputTypes: ['jfif'],
    outputTypes: ['png'],
    defaultOutput: 'png',
    category: 'image',
    icon: '🖼️'
  },
  'png-to-svg': {
    title: 'PNG to SVG Converter',
    description: 'Convert PNG images to SVG format.',
    inputTypes: ['png'],
    outputTypes: ['svg'],
    defaultOutput: 'svg',
    category: 'image',
    icon: '🖼️'
  },
  'heic-to-jpg': {
    title: 'HEIC to JPG Converter',
    description: 'Convert HEIC images to JPG format.',
    inputTypes: ['heic', 'heif'],
    outputTypes: ['jpg', 'jpeg'],
    defaultOutput: 'jpg',
    category: 'image',
    icon: '🖼️'
  },
  'heic-to-png': {
    title: 'HEIC to PNG Converter',
    description: 'Convert HEIC images to PNG format.',
    inputTypes: ['heic', 'heif'],
    outputTypes: ['png'],
    defaultOutput: 'png',
    category: 'image',
    icon: '🖼️'
  },
  'webp-to-jpg': {
    title: 'WEBP to JPG Converter',
    description: 'Convert WEBP images to JPG format.',
    inputTypes: ['webp'],
    outputTypes: ['jpg', 'jpeg'],
    defaultOutput: 'jpg',
    category: 'image',
    icon: '🖼️'
  },
  'svg-converter': {
    title: 'SVG Converter',
    description: 'Convert SVG files to PNG, JPG, PDF and other formats.',
    inputTypes: ['svg'],
    outputTypes: ['png', 'jpg', 'jpeg', 'pdf', 'webp'],
    category: 'image',
    icon: '🖼️'
  },
  'tiff-converter': {
    title: 'TIFF Converter',
    description: 'Convert TIFF images to JPG, PNG, WEBP and other formats.',
    inputTypes: ['tiff', 'tif'],
    outputTypes: ['jpg', 'jpeg', 'png', 'webp', 'bmp'],
    category: 'image',
    icon: '🖼️'
  },
  'bmp-converter': {
    title: 'BMP Converter',
    description: 'Convert BMP images to JPG, PNG, WEBP and other formats.',
    inputTypes: ['bmp'],
    outputTypes: ['jpg', 'jpeg', 'png', 'webp', 'tiff'],
    category: 'image',
    icon: '🖼️'
  },
  'ico-converter': {
    title: 'ICO Converter',
    description: 'Convert ICO icon files to PNG, JPG and other formats.',
    inputTypes: ['ico'],
    outputTypes: ['png', 'jpg', 'jpeg', 'webp'],
    category: 'image',
    icon: '🖼️'
  },
  'apng-converter': {
    title: 'APNG Converter',
    description: 'Convert APNG animated images to GIF, PNG and other formats.',
    inputTypes: ['apng'],
    outputTypes: ['gif', 'png', 'webp'],
    category: 'image',
    icon: '🖼️'
  },

  // PDF & Documents (10项)
  'pdf-converter': {
    title: 'PDF Converter',
    description: 'Convert PDF files to Word, HTML, TXT, JPG, EPUB and more formats.',
    inputTypes: ['pdf'],
    outputTypes: ['docx', 'doc', 'html', 'txt', 'jpg', 'png', 'epub'],
    category: 'document',
    icon: '📄'
  },
  'document-converter': {
    title: 'Document Converter',
    description: 'Convert documents between PDF, Word, HTML, TXT, RTF and more formats.',
    inputTypes: ['commonmark', 'commonmark_x', 'csv', 'docbook', 'docx', 'doc', 'dokuwiki', 'epub', 'fb2', 'gfm', 'haddock', 'html', 'ipynb', 'jats', 'jira', 'man', 'markdown', 'md', 'mediawiki', 'muse', 'native', 'ods', 'odt', 'opml', 'org', 'pdf', 'rst', 'rtf', 'textile', 'txt', 'xlsx', 'pptx', 'ppt', 'xls'],
    outputTypes: ['pdf', 'docx', 'doc', 'txt', 'rtf', 'odt', 'html', 'md', 'epub', 'xlsx', 'ods', 'csv'],
    category: 'document',
    icon: '📄'
  },
  'ebook-converter': {
    title: 'Ebook Converter',
    description: 'Convert ebooks between EPUB, MOBI, PDF and more formats.',
    inputTypes: ['epub', 'mobi', 'pdf'],
    outputTypes: ['epub', 'pdf'],
    category: 'document',
    icon: '📚'
  },
  'pdf-to-word': {
    title: 'PDF to Word Converter',
    description: 'Convert PDF files to Word DOCX format.',
    inputTypes: ['pdf'],
    outputTypes: ['docx', 'doc'],
    defaultOutput: 'docx',
    category: 'document',
    icon: '📄',
    appOnly: true
  },
  'pdf-to-jpg': {
    title: 'PDF to JPG Converter',
    description: 'Convert PDF pages to JPG images.',
    inputTypes: ['pdf'],
    outputTypes: ['jpg', 'jpeg', 'png'],
    defaultOutput: 'jpg',
    category: 'document',
    icon: '📄'
  },
  'pdf-to-epub': {
    title: 'PDF to EPUB Converter',
    description: 'Convert PDF files to EPUB ebook format.',
    inputTypes: ['pdf'],
    outputTypes: ['epub'],
    defaultOutput: 'epub',
    category: 'document',
    icon: '📚'
  },
  'epub-to-pdf': {
    title: 'EPUB to PDF Converter',
    description: 'Convert EPUB ebooks to PDF format.',
    inputTypes: ['epub'],
    outputTypes: ['pdf'],
    defaultOutput: 'pdf',
    category: 'document',
    icon: '📚'
  },
  'heic-to-pdf': {
    title: 'HEIC to PDF Converter',
    description: 'Convert HEIC images to PDF format.',
    inputTypes: ['heic', 'heif'],
    outputTypes: ['pdf'],
    defaultOutput: 'pdf',
    category: 'document',
    icon: '📄'
  },
  'docx-to-pdf': {
    title: 'DOCX to PDF Converter',
    description: 'Convert Word DOCX documents to PDF format.',
    inputTypes: ['docx', 'doc'],
    outputTypes: ['pdf'],
    defaultOutput: 'pdf',
    category: 'document',
    icon: '📄'
  },
  'jpg-to-pdf': {
    title: 'JPG to PDF Converter',
    description: 'Convert JPG images to PDF format.',
    inputTypes: ['jpg', 'jpeg', 'png'],
    outputTypes: ['pdf'],
    defaultOutput: 'pdf',
    category: 'document',
    icon: '📄'
  },
  'jpg-to-word': {
    title: 'JPG to Word Converter',
    description: 'Convert JPG images to editable Word DOCX format.',
    inputTypes: ['jpg', 'jpeg'],
    outputTypes: ['docx'],
    defaultOutput: 'docx',
    category: 'document',
    icon: '📄'
  },
  'pdf-to-html': {
    title: 'PDF to HTML Converter',
    description: 'Convert PDF files to HTML format.',
    inputTypes: ['pdf'],
    outputTypes: ['html'],
    defaultOutput: 'html',
    category: 'document',
    icon: '📄'
  },
  'pdf-to-txt': {
    title: 'PDF to TXT Converter',
    description: 'Convert PDF files to TXT text format.',
    inputTypes: ['pdf'],
    outputTypes: ['txt'],
    defaultOutput: 'txt',
    category: 'document',
    icon: '📄'
  },
  'html-to-pdf': {
    title: 'HTML to PDF Converter',
    description: 'Convert HTML files to PDF format.',
    inputTypes: ['html', 'htm'],
    outputTypes: ['pdf'],
    defaultOutput: 'pdf',
    category: 'document',
    icon: '📄'
  },
  'txt-to-pdf': {
    title: 'TXT to PDF Converter',
    description: 'Convert TXT text files to PDF format.',
    inputTypes: ['txt'],
    outputTypes: ['pdf'],
    defaultOutput: 'pdf',
    category: 'document',
    icon: '📄'
  },
  'docx-to-html': {
    title: 'DOCX to HTML Converter',
    description: 'Convert Word DOCX documents to HTML format.',
    inputTypes: ['docx', 'doc'],
    outputTypes: ['html'],
    defaultOutput: 'html',
    category: 'document',
    icon: '📄'
  },
  'rtf-converter': {
    title: 'RTF Converter',
    description: 'Convert RTF documents to PDF, DOCX, TXT and other formats.',
    inputTypes: ['rtf'],
    outputTypes: ['pdf', 'docx', 'txt', 'html'],
    category: 'document',
    icon: '📄'
  },
  'md-converter': {
    title: 'Markdown Converter',
    description: 'Convert Markdown files to PDF, HTML, DOCX and other formats.',
    inputTypes: ['md', 'markdown'],
    outputTypes: ['pdf', 'html', 'docx', 'txt'],
    category: 'document',
    icon: '📄'
  },

  // GIF (9项)
  'video-to-gif': {
    title: 'Video to GIF Converter',
    description: 'Convert videos to animated GIF format.',
    inputTypes: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm'],
    outputTypes: ['gif'],
    defaultOutput: 'gif',
    category: 'video',
    icon: '🎬'
  },
  'mp4-to-gif': {
    title: 'MP4 to GIF Converter',
    description: 'Convert MP4 videos to animated GIF format.',
    inputTypes: ['mp4'],
    outputTypes: ['gif'],
    defaultOutput: 'gif',
    category: 'video',
    icon: '🎬'
  },
  'webm-to-gif': {
    title: 'WEBM to GIF Converter',
    description: 'Convert WEBM videos to animated GIF format.',
    inputTypes: ['webm'],
    outputTypes: ['gif'],
    defaultOutput: 'gif',
    category: 'video',
    icon: '🎬'
  },
  'apng-to-gif': {
    title: 'APNG to GIF Converter',
    description: 'Convert APNG animated images to GIF format.',
    inputTypes: ['apng'],
    outputTypes: ['gif'],
    defaultOutput: 'gif',
    category: 'image',
    icon: '🖼️'
  },
  'gif-to-mp4': {
    title: 'GIF to MP4 Converter',
    description: 'Convert animated GIFs to MP4 video format.',
    inputTypes: ['gif'],
    outputTypes: ['mp4'],
    defaultOutput: 'mp4',
    category: 'video',
    icon: '🎬'
  },
  'gif-to-apng': {
    title: 'GIF to APNG Converter',
    description: 'Convert GIF animations to APNG format.',
    inputTypes: ['gif'],
    outputTypes: ['apng'],
    defaultOutput: 'apng',
    category: 'image',
    icon: '🖼️'
  },
  'image-to-gif': {
    title: 'Image to GIF Converter',
    description: 'Convert images to GIF format.',
    inputTypes: ['jpg', 'jpeg', 'png', 'bmp', 'webp'],
    outputTypes: ['gif'],
    defaultOutput: 'gif',
    category: 'image',
    icon: '🖼️'
  },
  'mov-to-gif': {
    title: 'MOV to GIF Converter',
    description: 'Convert MOV videos to animated GIF format.',
    inputTypes: ['mov'],
    outputTypes: ['gif'],
    defaultOutput: 'gif',
    category: 'video',
    icon: '🎬'
  },
  'avi-to-gif': {
    title: 'AVI to GIF Converter',
    description: 'Convert AVI videos to animated GIF format.',
    inputTypes: ['avi'],
    outputTypes: ['gif'],
    defaultOutput: 'gif',
    category: 'video',
    icon: '🎬'
  },

  // Others (3项)
  'unit-converter': {
    title: 'Unit Converter',
    description: 'Convert between different units of measurement.',
    inputTypes: [],
    outputTypes: [],
    category: 'other',
    icon: '📏',
    isSpecial: true // 特殊工具，不使用文件转换
  },
  'archive-converter': {
    title: 'Archive Converter',
    description: 'Convert archive files between ZIP, RAR, 7Z and more formats.',
    inputTypes: ['zip', 'rar', '7z'],
    outputTypes: ['zip', 'rar', '7z'],
    category: 'archive',
    icon: '📦',
    appOnly: true
  }
};

export const compressToolConfigs = {
  // Video & Audio (8项)
  'video-compressor': {
    title: 'Video Compressor',
    description: 'Compress video files to reduce file size while maintaining quality.',
    inputTypes: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'],
    outputTypes: ['mp4'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'audio-compressor': {
    title: 'Audio Compressor',
    description: 'Compress audio files to reduce file size.',
    inputTypes: ['mp3', 'wav', 'flac', 'aac', 'ogg', 'm4a'],
    outputTypes: ['mp3'],
    category: 'audio',
    icon: '🎵',
    mode: 'compress'
  },
  'mp3-compressor': {
    title: 'MP3 Compressor',
    description: 'Compress MP3 audio files to reduce file size.',
    inputTypes: ['mp3'],
    outputTypes: ['mp3'],
    category: 'audio',
    icon: '🎵',
    mode: 'compress'
  },
  'mp4-compressor': {
    title: 'MP4 Compressor',
    description: 'Compress MP4 video files to reduce file size.',
    inputTypes: ['mp4'],
    outputTypes: ['mp4'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'avi-compressor': {
    title: 'AVI Compressor',
    description: 'Compress AVI video files to reduce file size.',
    inputTypes: ['avi'],
    outputTypes: ['mp4'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'mov-compressor': {
    title: 'MOV Compressor',
    description: 'Compress MOV video files to reduce file size.',
    inputTypes: ['mov'],
    outputTypes: ['mp4'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'wmv-compressor': {
    title: 'WMV Compressor',
    description: 'Compress WMV video files to reduce file size.',
    inputTypes: ['wmv'],
    outputTypes: ['mp4'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'flv-compressor': {
    title: 'FLV Compressor',
    description: 'Compress FLV video files to reduce file size.',
    inputTypes: ['flv'],
    outputTypes: ['mp4'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },

  // Image (8项)
  'image-compressor': {
    title: 'Image Compressor',
    description: 'Compress images to reduce file size while maintaining visual quality.',
    inputTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
    outputTypes: ['jpg', 'jpeg', 'png', 'webp'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-jpg': {
    title: 'JPG Compressor',
    description: 'Compress JPG images to reduce file size.',
    inputTypes: ['jpg', 'jpeg'],
    outputTypes: ['jpg'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-png': {
    title: 'PNG Compressor',
    description: 'Compress PNG images to reduce file size.',
    inputTypes: ['png'],
    outputTypes: ['png'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-gif': {
    title: 'GIF Compressor',
    description: 'Compress GIF images to reduce file size.',
    inputTypes: ['gif'],
    outputTypes: ['gif'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-webp': {
    title: 'WEBP Compressor',
    description: 'Compress WEBP images to reduce file size.',
    inputTypes: ['webp'],
    outputTypes: ['webp'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-bmp': {
    title: 'BMP Compressor',
    description: 'Compress BMP images to reduce file size.',
    inputTypes: ['bmp'],
    outputTypes: ['jpg', 'png', 'webp'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-tiff': {
    title: 'TIFF Compressor',
    description: 'Compress TIFF images to reduce file size.',
    inputTypes: ['tiff', 'tif'],
    outputTypes: ['jpg', 'png', 'webp'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-svg': {
    title: 'SVG Compressor',
    description: 'Compress SVG files by removing unnecessary code.',
    inputTypes: ['svg'],
    outputTypes: ['svg'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },

  // PDF & Documents (8项)
  'compress-pdf': {
    title: 'PDF Compressor',
    description: 'Compress PDF files to reduce file size.',
    inputTypes: ['pdf'],
    outputTypes: ['pdf'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },
  'compress-word': {
    title: 'Word Compressor',
    description: 'Compress Word documents by removing unnecessary formatting.',
    inputTypes: ['docx', 'doc'],
    outputTypes: ['docx'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },
  'compress-powerpoint': {
    title: 'PowerPoint Compressor',
    description: 'Compress PowerPoint presentations to reduce file size.',
    inputTypes: ['pptx', 'ppt'],
    outputTypes: ['pptx'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },
  'compress-excel': {
    title: 'Excel Compressor',
    description: 'Compress Excel spreadsheets to reduce file size.',
    inputTypes: ['xlsx', 'xls'],
    outputTypes: ['xlsx'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },
  'compress-txt': {
    title: 'TXT Compressor',
    description: 'Compress text files to reduce file size.',
    inputTypes: ['txt'],
    outputTypes: ['txt'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },
  'compress-rtf': {
    title: 'RTF Compressor',
    description: 'Compress RTF documents to reduce file size.',
    inputTypes: ['rtf'],
    outputTypes: ['rtf'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },
  'compress-odt': {
    title: 'ODT Compressor',
    description: 'Compress ODT documents to reduce file size.',
    inputTypes: ['odt'],
    outputTypes: ['odt'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },
  'compress-pages': {
    title: 'Pages Compressor',
    description: 'Compress Pages documents to reduce file size.',
    inputTypes: ['pages'],
    outputTypes: ['pages'],
    category: 'document',
    icon: '📄',
    mode: 'compress'
  },

  // GIF (8项)
  'gif-compressor': {
    title: 'GIF Compressor',
    description: 'Compress GIF animations to reduce file size.',
    inputTypes: ['gif'],
    outputTypes: ['gif'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-animated-gif': {
    title: 'Animated GIF Compressor',
    description: 'Compress animated GIFs to reduce file size.',
    inputTypes: ['gif'],
    outputTypes: ['gif'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  },
  'compress-video-to-gif': {
    title: 'Video to GIF Compressor',
    description: 'Convert and compress videos to optimized GIF format.',
    inputTypes: ['mp4', 'avi', 'mov', 'webm'],
    outputTypes: ['gif'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'compress-mp4-to-gif': {
    title: 'MP4 to GIF Compressor',
    description: 'Convert and compress MP4 videos to optimized GIF format.',
    inputTypes: ['mp4'],
    outputTypes: ['gif'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'compress-webm-to-gif': {
    title: 'WEBM to GIF Compressor',
    description: 'Convert and compress WEBM videos to optimized GIF format.',
    inputTypes: ['webm'],
    outputTypes: ['gif'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'compress-avi-to-gif': {
    title: 'AVI to GIF Compressor',
    description: 'Convert and compress AVI videos to optimized GIF format.',
    inputTypes: ['avi'],
    outputTypes: ['gif'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'compress-mov-to-gif': {
    title: 'MOV to GIF Compressor',
    description: 'Convert and compress MOV videos to optimized GIF format.',
    inputTypes: ['mov'],
    outputTypes: ['gif'],
    category: 'video',
    icon: '🎬',
    mode: 'compress'
  },
  'compress-apng': {
    title: 'APNG Compressor',
    description: 'Compress APNG animations to reduce file size.',
    inputTypes: ['apng'],
    outputTypes: ['apng', 'gif'],
    category: 'image',
    icon: '🖼️',
    mode: 'compress'
  }
};

export const toolsConfigs = {
  // Video Tools (8项)
  'video-speed-changer': {
    title: 'Video Speed Changer',
    description: 'Change the playback speed of video files.',
    inputTypes: ['mp4', 'avi', 'mov', 'webm'],
    category: 'video',
    icon: '🎬',
    toolType: 'video-speed'
  },
  'video-trimmer': {
    title: 'Video Trimmer',
    description: 'Trim and cut video files to remove unwanted parts.',
    inputTypes: ['mp4', 'avi', 'mov', 'webm'],
    category: 'video',
    icon: '✂️',
    toolType: 'video-trim'
  },
  'video-cropper': {
    title: 'Video Cropper',
    description: 'Crop video files to focus on specific areas.',
    inputTypes: ['mp4', 'avi', 'mov', 'webm'],
    category: 'video',
    icon: '📐',
    toolType: 'video-crop'
  },
  'video-rotator': {
    title: 'Video Rotator',
    description: 'Rotate video files to correct orientation.',
    inputTypes: ['mp4', 'avi', 'mov', 'webm'],
    category: 'video',
    icon: '🔄',
    toolType: 'video-rotate'
  },
  'video-merger': {
    title: 'Video Merger',
    description: 'Merge multiple video files into one.',
    inputTypes: ['mp4', 'avi', 'mov', 'webm'],
    category: 'video',
    icon: '🔗',
    toolType: 'video-merge',
    allowMultiple: true
  },
  'video-splitter': {
    title: 'Video Splitter',
    description: 'Split video files into multiple segments.',
    inputTypes: ['mp4', 'avi', 'mov', 'webm'],
    category: 'video',
    icon: '✂️',
    toolType: 'video-split'
  },

  // Image Tools (8项)
  'image-resizer': {
    title: 'Image Resizer',
    description: 'Resize images to different dimensions.',
    inputTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
    category: 'image',
    icon: '📏',
    toolType: 'image-resize'
  },
  'image-cropper': {
    title: 'Image Cropper',
    description: 'Crop images to focus on specific areas.',
    inputTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
    category: 'image',
    icon: '✂️',
    toolType: 'image-crop'
  },
  'image-rotator': {
    title: 'Image Rotator',
    description: 'Rotate images to correct orientation.',
    inputTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
    category: 'image',
    icon: '🔄',
    toolType: 'image-rotate'
  },
  'image-flipper': {
    title: 'Image Flipper',
    description: 'Flip images horizontally or vertically.',
    inputTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
    category: 'image',
    icon: '↔️',
    toolType: 'image-flip'
  },
  'image-enhancer': {
    title: 'Image Enhancer',
    description: 'Enhance image quality and adjust brightness, contrast, and saturation.',
    inputTypes: ['jpg', 'jpeg', 'png', 'bmp', 'webp'],
    category: 'image',
    icon: '✨',
    toolType: 'image-enhance'
  },
  'image-watermark': {
    title: 'Image Watermark',
    description: 'Add text or image watermarks to images.',
    inputTypes: ['jpg', 'jpeg', 'png', 'bmp', 'webp'],
    category: 'image',
    icon: '💧',
    toolType: 'image-watermark'
  },

  // PDF Tools (12项)
  'pdf-merger': {
    title: 'PDF Merger',
    description: 'Merge multiple PDF files into one.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '🔗',
    toolType: 'pdf-merge',
    allowMultiple: true
  },
  'pdf-splitter': {
    title: 'PDF Splitter',
    description: 'Split PDF files into multiple documents.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '✂️',
    toolType: 'pdf-split'
  },
  'pdf-rotator': {
    title: 'PDF Rotator',
    description: 'Rotate PDF pages to correct orientation.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '🔄',
    toolType: 'pdf-rotate'
  },
  'pdf-cropper': {
    title: 'PDF Cropper',
    description: 'Crop PDF pages to remove margins or unwanted areas.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '📐',
    toolType: 'pdf-crop'
  },
  'pdf-password-remover': {
    title: 'PDF Password Remover',
    description: 'Remove password protection from PDF files.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '🔓',
    toolType: 'pdf-remove-password'
  },
  'pdf-password-protector': {
    title: 'PDF Password Protector',
    description: 'Add password protection to PDF files.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '🔒',
    toolType: 'pdf-add-password'
  },
  'pdf-page-remover': {
    title: 'PDF Page Remover',
    description: 'Remove specific pages from PDF files.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '🗑️',
    toolType: 'pdf-remove-pages'
  },
  'pdf-page-extractor': {
    title: 'PDF Page Extractor',
    description: 'Extract specific pages from PDF files.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '📑',
    toolType: 'pdf-extract-pages'
  },
  'pdf-image-extractor': {
    title: 'PDF Image Extractor',
    description: 'Extract images from PDF files.',
    inputTypes: ['pdf'],
    category: 'document',
    icon: '🖼️',
    toolType: 'pdf-extract-images'
  },
  'pdf-to-images': {
    title: 'PDF to Images',
    description: 'Convert PDF pages to image files.',
    inputTypes: ['pdf'],
    outputTypes: ['jpg', 'jpeg', 'png'],
    category: 'document',
    icon: '🖼️',
    toolType: 'pdf-to-images'
  },
  'images-to-pdf': {
    title: 'Images to PDF',
    description: 'Combine multiple images into one PDF file.',
    inputTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
    outputTypes: ['pdf'],
    category: 'document',
    icon: '📄',
    toolType: 'images-to-pdf',
    allowMultiple: true
  }
};

// 合并所有配置以便快速查找
export const allToolConfigs = {
  ...convertToolConfigs,
  ...compressToolConfigs,
  ...toolsConfigs
};

// 根据路径获取工具配置
export function getToolConfig(path) {
  // 移除前导斜杠
  const cleanPath = path.replace(/^\//, '');
  
  // 尝试直接匹配
  if (allToolConfigs[cleanPath]) {
    return allToolConfigs[cleanPath];
  }
  
  // 尝试从 convert/compress/tools 路径中提取
  const pathParts = cleanPath.split('/');
  if (pathParts.length > 1) {
    const toolName = pathParts[pathParts.length - 1];
    if (allToolConfigs[toolName]) {
      return allToolConfigs[toolName];
    }
  }
  
  // 默认配置
  return {
    title: 'File Converter',
    description: 'Convert and process your files locally',
    inputTypes: [],
    outputTypes: [],
    category: 'other',
    icon: '📁'
  };
}




